module.exports = __webpack_public_path__ + "static/media/charger-pin-default.b3521155.svg";